import { Tabs } from "antd";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function CustomTabs({ items }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "1";
  const [activeKey, setActiveKey] = useState(tabFromUrl);

  useEffect(() => {
    setActiveKey(tabFromUrl);
  }, [tabFromUrl]);

  const handleTabChange = (key) => {
    setActiveKey(key);
    setSearchParams({ tab: key });
  };

  return (
    <div className="w-full ">
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        items={items.map((item) => ({
          ...item,
          label: (
            <span
              className={`text-base font-semibold transition-colors duration-200 ${
                activeKey === item.key ? "text-[var(--color-primary)]" : "text-gray-600"
              }`}
            >
              {item.label}
            </span>
          ),
        }))}
        className="
          [&_.ant-tabs-nav]:bg-white 
          [&_.ant-tabs-nav]:rounded-md
          [&_.ant-tabs-nav]:px-4
          [&_.ant-tabs-nav-list]:w-full 
          [&_.ant-tabs-nav-list]:justify-between 
          [&_.ant-tabs-tab]:flex-1 
          [&_.ant-tabs-tab]:justify-center 
          [&_.ant-tabs-ink-bar]:!bg-[var(--color-primary)] 
          [&_.ant-tabs-ink-bar]:!h-[4px] 
          [&_.ant-tabs-ink-bar]:!rounded-md
          [&_.ant-tabs-ink-bar]:!w-[10%] 
          [&_.ant-tabs-nav]:border-b-0
        "
      />
    </div>
  );
}